import React, { useState } from "react";
import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";
import { Flex } from "antd";
import TitleNavigateButton from "@components/button/TitleNavigateButton";
import useUserInfoStore from "@store/useUserInfoStore";
import BasicModal from "@components/modal/BasicModal";
import { useNavigate } from "react-router-dom";
import Image from "@components/item/Image";
import { useTranslation } from "react-i18next";

const Container = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "calc(100vh - 8rem)",
  backgroundImage: `linear-gradient(rgba(17, 17, 17, 0.5), rgba(17, 17, 17, 0.5)), url(${theme.image.main_register_bg})`,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  color: theme.color.white,
  fontSize: "2rem",
  fontWeight: theme.fontWeight.medium,
  lineHeight: "2.8rem",
  textAlign: "center",
  gap: "4.3rem",
  position: "relative",
  zIndex: 1,
  padding: "0 2rem",
}));

const StyledButton = styled.button(({ theme }) => ({
  all: "unset",
  padding: "1.6rem 2rem",
  backgroundColor: theme.color.mint,
  color: "#222",
  cursor: "pointer",
  fontSize: "1.6rem",
  fontWeight: 500,
  width: "-webkit-fill-available",
}));

const MoreButton = styled.button(({ theme }) => ({
  all: "unset",
  color: theme.color.white,
  cursor: "pointer",
  fontSize: "1.6rem",
  fontWeight: 400,
}));

const ModalText = styled.div({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "1.6rem",
  fontWeight: 500,
  lineHeight: "2.4rem",
  paddingBottom: "4.4rem",
});

const MainRegister = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [policyModal, setPolicyModal] = useState(false);
  const [accountModal, setAccountModal] = useState(false);

  const { t } = useTranslation();

  const { userInfo } = useUserInfoStore();

  const isSalesPolicy =
    userInfo?.shipping_fee !== null || userInfo?.free_shipping_fee !== null;

  const isAccount = userInfo?.account_number !== null;

  const handleNavigateRegister = () => {
    if (isSalesPolicy && isAccount) {
      navigate("/register", {
        replace: true,
      });
    } else if (!isSalesPolicy) {
      setPolicyModal(true);
    } else if (!isAccount) {
      setAccountModal(true);
    }
  };

  return (
    <Container>
      <Flex vertical>
        <span>{t("주문이 끊긴 이월상품에")}</span>
        <span>{t("두번째 가치를 부여해주세요.")}</span>
      </Flex>

      <StyledButton theme={theme} onClick={handleNavigateRegister}>
        {t("상품 등록 하기")}
      </StyledButton>

      <MoreButton onClick={() => navigate("/product-popup")}>
        {t("더 알아보기")}
      </MoreButton>

      <BasicModal
        open={policyModal}
        setOpen={setPolicyModal}
        activeName="판매자 정책 설정하기"
        activeEvent={() => navigate("/sales-policy")}
        closeName="취소">
        <Flex vertical gap="2rem" align="center">
          <Image src={theme.image.warning_circle_thin.default} size="4.8rem" />
          <ModalText>
            <span>{t("판매자 정책 설정이 안되어 있어요!")}</span>
            <span style={{ textAlign: "center" }}>
              {t("설정을 완료하신 후 등록을 진행해주세요")}
            </span>
          </ModalText>
        </Flex>
      </BasicModal>

      <BasicModal
        open={accountModal}
        setOpen={setAccountModal}
        activeName="계좌 등록하기"
        activeEvent={() => navigate("/bank-account-management")}
        closeName="취소">
        <Flex vertical gap="2rem" align="center">
          <Image src={theme.image.warning_circle_thin.default} size="4.8rem" />
          <ModalText>
            <span style={{ fontWeight: 700 }}>
              {t("계좌 등록이 안되어 있어요!")}
            </span>
            <span style={{ textAlign: "center" }}>
              {t("계좌등록을 완료하신 후 등록을 진행해주세요")}
            </span>
          </ModalText>
        </Flex>
      </BasicModal>
    </Container>
  );
};

export default MainRegister;
